import { useQuery } from '@apollo/client';
import type { ApolloError } from '@apollo/client';

import EnterpriseProgramQuery from 'bundles/enterprise-legacy-learner-home/queries/EnterpriseProgramQuery.graphql';
import type {
  EnterpriseProgramQueryQueryVariables,
  EnterpriseProgramQueryQuery as EnterpriseProgramQueryType,
} from 'bundles/enterprise-legacy-learner-home/queries/__generated__/EnterpriseProgramQuery';

type UseProgramDataReturn = {
  loading: boolean;
  error?: ApolloError;
  programSlug: string | null;
  orgSlug: string | null;
  data: EnterpriseProgramQueryType | undefined;
};

/**
 * Hook for fetching program data using GraphQL
 *
 * @param programId - The program ID to fetch data for
 * @returns Object containing loading state, error, program slug, org slug, and raw GraphQL data
 */
export const useProgramData = (programId: string | null | undefined): UseProgramDataReturn => {
  const { loading, error, data } = useQuery<EnterpriseProgramQueryType, EnterpriseProgramQueryQueryVariables>(
    EnterpriseProgramQuery,
    {
      variables: { programIds: programId ? [programId] : [] },
      context: { clientName: 'gatewayGql' },
      skip: !programId,
    }
  );

  const program = data?.EnterpriseProgram?.queryByIds?.elements?.[0];
  const programSlug = program?.slug || null;
  const orgSlug = program?.naptimeThirdPartyOrganization?.slug || null;

  return {
    loading,
    error,
    programSlug,
    orgSlug,
    data,
  };
};
